import { render, staticRenderFns } from "./newProfile.vue?vue&type=template&id=0dbf896e&scoped=true"
import script from "./newProfile.vue?vue&type=script&lang=js"
export * from "./newProfile.vue?vue&type=script&lang=js"
import style0 from "./newProfile.vue?vue&type=style&index=0&id=0dbf896e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dbf896e",
  null
  
)

export default component.exports